import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { TransactionFeeType } from '__generated__/GQL';
import { getFeesForType } from 'common/fees';
import SunshineCard from 'components/_core/SunshineCard';

import { InvoiceFormSchema } from '../../../../../../../../../form/invoiceForm.schema';
import { PaymentDescriptionList } from '../PaymentDescriptionList';
import locales from './locales';

const descriptionItems = [
  locales.formatString(
    locales.ibanPaymentDescription,
    getFeesForType(TransactionFeeType.AdditionalTransfer),
  ),
  locales.formatString(
    locales.swiftPaymentDescription,
    getFeesForType(TransactionFeeType.SwiftTransferPayin),
  ),
];

export const IbanPayment: FC = () => {
  const { control } = useFormContext<InvoiceFormSchema>();

  return (
    <Controller
      control={control}
      name="allowIbanPayment"
      render={({ field }) => (
        <SunshineCard
          isChecked={field.value}
          onChange={field.onChange}
          variant="checkbox"
        >
          <SunshineCard.Content>
            <SunshineCard.Title>{locales.ibanPayment}</SunshineCard.Title>

            <SunshineCard.Text>
              <PaymentDescriptionList items={descriptionItems} />
            </SunshineCard.Text>
          </SunshineCard.Content>
        </SunshineCard>
      )}
    />
  );
};
